/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Partner Development
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

// Dashboard panels

var calendarData = {};
var selectData = {};
class Dashboard {
  constructor(viewer) {
    var _this = this;
    this._viewer = viewer;

    this._viewer.addEventListener(
      Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
      function () {
        _this._viewer.resize();
        _this.loadPanels();
      }
    );

    showPanelLoadingScreen();
  }

  loadPanels() {
    // Load issues
    loadIssues();

    // Load data
    var data = new ModelData(this._viewer);

    data.init(function () {
      // Chart data
      var container = $('#panel-content-chart__node-list');

      // console.log(data._chartData);

      if (data._chartData) {
        var selectContainer = $('#panel-content-chart__charts-select');
        $.each(data._chartData, function (name, data) {
          addNodeToggler(name, data, container, viewer);
          selectData[name] = data;
          selectContainer.append(
            $('<option value="' + name + '"/>')
              .data('data', data)
              .html(name)
          );
        });
      }

      // Categorize calendar
      var calendar = settings.calendar;

      $.each(data._calendarData, function (dbId, item) {
        dbId = parseInt(dbId);

        // Abort if mandatory data is missing
        if (
          !item[calendar.startPropertyIs] ||
          !item[calendar.endPropertyIs] ||
          !item[calendar.startPropertyShould] ||
          !item[calendar.endPropertyShould] ||
          !item[calendar.level1] ||
          !item[calendar.level2] ||
          !item[calendar.level3]
        ) {
          return;
        }

        // Level 1
        if (!calendarData[item[calendar.level1]]) {
          calendarData[item[calendar.level1]] = {
            startIs: item[calendar.startPropertyIs],
            endIs: item[calendar.endPropertyIs],
            startShould: item[calendar.startPropertyShould],
            endShould: item[calendar.endPropertyShould],
            start: getSmallerFormattedDate(
              item[calendar.startPropertyIs],
              item[calendar.startPropertyShould]
            ),
            end: getLargerFormattedDate(
              item[calendar.endPropertyIs],
              item[calendar.endPropertyShould]
            ),
            ids: [],
            children: {},
            data: item
          };
        }
        calendarData[item[calendar.level1]].ids.push(dbId);

        // Adjust level 1 is and should dates
        calendarData[item[calendar.level1]].startIs = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].startIs,
          item[calendar.startPropertyIs]
        );
        calendarData[item[calendar.level1]].endIs = getLargerFormattedDate(
          calendarData[item[calendar.level1]].endIs,
          item[calendar.endPropertyIs]
        );
        calendarData[
          item[calendar.level1]
        ].startShould = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].startShould,
          item[calendar.startPropertyShould]
        );
        calendarData[item[calendar.level1]].endShould = getLargerFormattedDate(
          calendarData[item[calendar.level1]].endShould,
          item[calendar.endPropertyShould]
        );

        // Adjust level 1 start and end date
        calendarData[item[calendar.level1]].start = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].start,
          item[calendar.startPropertyIs]
        );
        calendarData[item[calendar.level1]].start = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].start,
          item[calendar.startPropertyShould]
        );
        calendarData[item[calendar.level1]].end = getLargerFormattedDate(
          calendarData[item[calendar.level1]].end,
          item[calendar.endPropertyIs]
        );
        calendarData[item[calendar.level1]].end = getLargerFormattedDate(
          calendarData[item[calendar.level1]].end,
          item[calendar.endPropertyShould]
        );

        // Level 2
        if (
          !calendarData[item[calendar.level1]].children[item[calendar.level2]]
        ) {
          calendarData[item[calendar.level1]].children[
            item[calendar.level2]
          ] = {
            startIs: item[calendar.startPropertyIs],
            endIs: item[calendar.endPropertyIs],
            startShould: item[calendar.startPropertyShould],
            endShould: item[calendar.endPropertyShould],
            start: getSmallerFormattedDate(
              item[calendar.startPropertyIs],
              item[calendar.startPropertyShould]
            ),
            end: getLargerFormattedDate(
              item[calendar.endPropertyIs],
              item[calendar.endPropertyShould]
            ),
            ids: [],
            children: {},
            data: item
          };
        }
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].ids.push(dbId);

        // Adjust level 2 is and should dates
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].startIs = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .startIs,
          item[calendar.startPropertyIs]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].endIs = getLargerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .endIs,
          item[calendar.endPropertyIs]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].startShould = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .startShould,
          item[calendar.startPropertyShould]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].endShould = getLargerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .endShould,
          item[calendar.endPropertyShould]
        );

        // Adjust level 2 start and end date
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].start = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .start,
          item[calendar.startPropertyIs]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].start = getSmallerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .start,
          item[calendar.startPropertyShould]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].end = getLargerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .end,
          item[calendar.endPropertyIs]
        );
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].end = getLargerFormattedDate(
          calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .end,
          item[calendar.endPropertyShould]
        );

        // Level 3
        if (
          !calendarData[item[calendar.level1]].children[item[calendar.level2]]
            .children[item[calendar.level3]]
        ) {
          calendarData[item[calendar.level1]].children[
            item[calendar.level2]
          ].children[item[calendar.level3]] = {
            startIs: item[calendar.startPropertyIs],
            endIs: item[calendar.endPropertyIs],
            startShould: item[calendar.startPropertyShould],
            endShould: item[calendar.endPropertyShould],
            start: getSmallerFormattedDate(
              item[calendar.startPropertyIs],
              item[calendar.startPropertyShould]
            ),
            end: getLargerFormattedDate(
              item[calendar.endPropertyIs],
              item[calendar.endPropertyShould]
            ),
            ids: [],
            children: {},
            data: item
          };
        }
        calendarData[item[calendar.level1]].children[
          item[calendar.level2]
        ].children[item[calendar.level3]].ids.push(dbId);
      });

      // All calendar data
      // console.log('calendarData', calendarData);

      // Calendar
      $('#panel-content-datepicker').html('');

      var picker = new Litepicker({
        element: document.getElementById('panel-content-datepicker-field'),
        parentEl: document.getElementById('panel-content-datepicker'),
        firstDay: 1,
        lang: settings.language,
        inlineMode: true,
        singleMode: false,
        format: 'YYYY-MM-DD',
        showTooltip: false,
        onSelect: function (start, end) {
          showCalendarData(start, end);
        }
      });

      var startOfWeek = moment().startOf('isoWeek');
      var endOfWeek = moment().endOf('isoWeek');

      picker.setDateRange(startOfWeek, endOfWeek);

      // Hacky solution to trigger 'picker.setDateRange'
      $('.calendar-panel__rows').trigger('click');

      // Add properties
      var treeStructure = settings.treeStructure;
      addPropertiesPanel(viewer, data, treeStructure);

      // Add selection events
      viewer.addEventListener(
        Autodesk.Viewing.SELECTION_CHANGED_EVENT,
        onSelectionEvent
      );

      // Hide loading screen
      hidePanelLoadingScreen();

      // Show calendar screen if needed
      if (localStorage.getItem('calendar-active') === 'true') {
        openPanel('calendar');
      }
    });
  }
}

// Get smaller or larger date

function getSmallerFormattedDate(date1, date2) {
  return getDateIntFromFormattedString(date2) <
    getDateIntFromFormattedString(date1)
    ? date2
    : date1;
}

function getLargerFormattedDate(date1, date2) {
  return getDateIntFromFormattedString(date2) >
    getDateIntFromFormattedString(date1)
    ? date2
    : date1;
}

function getDateIntFromFormattedString(formattedDate) {
  return parseInt(formattedDate.replace('-', '').replace('-', ''));
}

// Event handler for Autodesk.Viewing.SELECTION_CHANGED_EVENT

function onSelectionEvent(event) {
  // Abort if we don't have an event
  if (!event) {
    return;
  }

  // Abort if there are no properties
  if (!nodeProperties) {
    return;
  }

  // Abort if there is no viewer
  if (NOP_VIEWER === null || NOP_VIEWER === undefined) {
    return;
  }

  // Wrapper element
  var propertiesWrapper = $('.property-list__wrapper');

  // Reset list
  propertiesWrapper.html('');

  // Build property list
  var currSelection = NOP_VIEWER.getSelection();
  var propertiesList = {};

  if (currSelection.length === 1) {
    $.each(currSelection, function (index, item) {
      if (nodeProperties[item]) {
        var properties = nodeProperties[item];
        $.each(properties, function (index2, property) {
          propertiesList[property.displayName] = property.displayValue;
        });
      }
    });
  }

  // Order property list
  var orderedPropertiesList = {};
  Object.keys(propertiesList)
    .sort()
    .forEach(function (key) {
      orderedPropertiesList[key] = propertiesList[key];
    });

  // Build HTML
  var propertyLinks = [];

  $.each(orderedPropertiesList, function (propertyName, propertyValue) {
    if (
      propertyValue &&
      propertyValue !== '-' &&
      propertyValue !== '--' &&
      propertyValue !== '---' &&
      propertyValue !== 'unbekannt'
    ) {
      if (propertyName === 'Link') {
        var linkParts = propertyValue.split(';');
        var i;
        for (i = 0; i < linkParts.length; i++) {
          var link = linkParts[i].trim();
          if (link.indexOf('http') === 0 || link.indexOf('www.') === 0) {
            var linkNames = link.split('/');
            var linkName = linkNames[linkNames.length - 1];

            propertyLinks.push({
              propertyName: linkName,
              propertyValue: link
            });
          }
        }
      } else if (
        propertyValue.indexOf('http') === 0 ||
        propertyValue.indexOf('www.') === 0
      ) {
        propertyLinks.push({
          propertyName: propertyName,
          propertyValue: propertyValue
        });
      } else {
        //Dmue 20130316
        //propertiesWrapper.append(
        //  $('<div class="property__container"/>').html(
        //    '<b>' + propertyName + ':</b> <span>' + propertyValue + '</span>'
        //  )
        if(propertyName.indexOf('Forge') >= 0){
        propertiesWrapper.append(
          $('<div class="property__container"/>').html(
            //'<b> ' + propertyName + ':</b> <span>' + propertyValue + '</span>'
            '<b> ' + propertyName.replace('Forge_','') + ':</b> <span>' + propertyValue + '</span>'
          )          
        );
      }
      }
    }
  });

  if (propertyLinks.length) {
    propertiesWrapper.append(
      $('<div class="property__container property__container--title"/>').html(
        '<b>Links</b>'
      )
    );

    $.each(propertyLinks, function (index, property) {
      propertiesWrapper.append(
        $('<div class="property__container property__container--link"/>').html(
          '<b>' +
            property.propertyName +
            '</b><br><a href="' +
            property.propertyValue +
            '" target="_blank">' +
            parseLink(property.propertyValue) +
            '</a>'
        )
      );
    });
  }

  // Add empty notice
  if (!$('.property__container').length) {
    propertiesWrapper.append(
      $('<div class="panel__empty"/>').html(
        'There are no properties<br>with the current selection.'
      )
    );
  }
}

function parseLink(link) {
  if (link.length <= 32) {
    return link;
  }
  return link.substr(0, 16) + '...' + link.substr(-16, 16);
}
